import type { QueryEmailLogsArgs } from '@tribeplatform/gql-client/types'

import { KeyConstructor } from './keyConstructor.js'

const EMAIL_LOGS_KEY = 'emailLogs'

export const getEmailLogsKey = KeyConstructor<QueryEmailLogsArgs, never>(
  EMAIL_LOGS_KEY,
)
